import React, { useEffect, useState } from 'react';
import { styles } from './preferences-styles';
import { Button as MuiButton, Grid, Typography } from '@material-ui/core';
import LeftHandGraphic from '../media/LeftHanded.svg';
import RightHandGraphic from '../media/RightHanded.svg';
import RightHandSmallGraphic from '../media/RightHandedSmallForm.svg';
import LeftHandSmallGraphic from '../media/LeftHandedSmallForm.svg';
import clsx from 'clsx';

import RadioButton from './radio-button';
import { CashierPreferences } from '../../common/interfaces/dtos/CashierPreferences';
import { useTranslation } from 'react-i18next';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';

const DominantHandPreferences: React.FC<DominantHandPreferencesProps> = (props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const { userPreferences, updatePreferences } = props;
  const [isLeftHanded, setIsLeftHanded] = useState<boolean>(userPreferences.leftHanded);
  const { useSmallFormImages } = useResponsiveContext();

  useEffect(() => {
    updatePreferences('leftHanded', isLeftHanded);
  }, [isLeftHanded, updatePreferences]);

  return (
    <Grid
      container
      direction='row'
      className={classes.cashierPreferencesContentContainer}
      data-testid='dominant-hand-preferences-container'
    >
      <Grid item xs={6} className={classes.dominantOptionsContainer}>
        <Typography data-testid='left-hand-text'>{t('LHMode')}</Typography>
        <Grid
          container
          className={clsx({
            [classes.selectedContainer]: isLeftHanded,
            [classes.dominantHandUnSelectedContainer]: !isLeftHanded,
          })}
        >
          <MuiButton
            centerRipple
            className={classes.dominantHandImageButton}
            onClick={() => {
              setIsLeftHanded(true);
            }}
          >
            <img
              src={useSmallFormImages ? LeftHandSmallGraphic : LeftHandGraphic}
              alt={'LeftHandedGraphic'}
              className={classes.dominantHandImages}
              data-testid={useSmallFormImages ? 'left-hand-small-image' : 'left-hand-image'}
            />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='left-hand-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setIsLeftHanded(true);
              }}
            >
              <RadioButton isSelected={isLeftHanded} />
            </MuiButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.dominantOptionsContainer}>
        <Typography data-testid='right-hand-text'>{t('RHMode')}</Typography>
        <Grid
          container
          className={clsx({
            [classes.selectedContainer]: !isLeftHanded,
            [classes.dominantHandUnSelectedContainer]: isLeftHanded,
          })}
        >
          <MuiButton
            centerRipple
            className={classes.dominantHandImageButton}
            onClick={() => {
              setIsLeftHanded(false);
            }}
          >
            <img
              src={useSmallFormImages ? RightHandSmallGraphic : RightHandGraphic}
              alt={'RightHandedGraphic'}
              className={classes.dominantHandImages}
              data-testid={useSmallFormImages ? 'right-hand-small-image' : 'right-hand-image'}
            />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='right-hand-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setIsLeftHanded(false);
              }}
            >
              <RadioButton isSelected={!isLeftHanded} />
            </MuiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface DominantHandPreferencesProps {
  userPreferences: CashierPreferences;
  updatePreferences: (prefName: string, newValue: any) => void;
}

export default DominantHandPreferences;
